@if (template) {
  <div id="inspectionReportHtml" class="ipm-report ipm-report__report-container">
    <div id="report-element" [style.width]="'max(100%, ' + getPageSize().width + ')'" [style.height]="'calc(100%*1/' + scale + ')'">
      @for (page of filteredPages; track page; let pageIndex = $index) {
        <div
          class="ipm-report__page-frame"
          style="margin: 1mm auto; background-color: white"
          [style.width]="getPageSize().width"
          [style.height]="getPageSize().height"
        >
          <div [ngStyle]="getPageStyle()">
            <!-- Header-->
            <div [ngStyle]="getHeaderStyle(template.header, page)">
              <ng-container
                *ngTemplateOutlet="
                  textTemplate;
                  context: { texts: template.header.texts, pageNumber: pageIndex, pageCount: filteredPages.length }
                "
              >
              </ng-container>
              <ng-container *ngTemplateOutlet="imageTemplate; context: { images: template.header.images }"> </ng-container>
              <ng-container *ngTemplateOutlet="lineTemplate; context: { lines: template.header.lines }"> </ng-container>
              <ng-container *ngTemplateOutlet="rectTemplate; context: { rectangles: template.header.rectangles }"> </ng-container>
              <ng-container *ngTemplateOutlet="signatureTemplate; context: { signs: template.header.signatures }"> </ng-container>
            </div>
            <!--Content-->
            <div style="position: relative">
              <ng-container
                *ngTemplateOutlet="textTemplate; context: { texts: page.texts, pageNumber: pageIndex, pageCount: filteredPages.length }"
              >
              </ng-container>
              <ng-container *ngTemplateOutlet="imageTemplate; context: { images: page.images }"> </ng-container>
              <ng-container *ngTemplateOutlet="lineTemplate; context: { lines: page.lines }"> </ng-container>
              <ng-container *ngTemplateOutlet="rectTemplate; context: { rectangles: page.rectangles }"> </ng-container>
              <ng-container *ngTemplateOutlet="dropDownListsTemplate; context: { dropdownLists: page.dropDownLists }"> </ng-container>
              <ng-container *ngTemplateOutlet="isoTemplate; context: { interactiveIso: page.interactiveIso }"> </ng-container>
              <ng-container *ngTemplateOutlet="veTemplate; context: { visualEvents: page.visualEvents }"> </ng-container>
              <ng-container *ngTemplateOutlet="measurementPointTemplate; context: { measurementPoints: page.measurementPoints }">
              </ng-container>
              <ng-container *ngTemplateOutlet="signatureTemplate; context: { signs: page.signatures }"> </ng-container>
              <ng-container *ngTemplateOutlet="tableTemplate; context: { tables: page.tables }"> </ng-container>
            </div>
            <!--Footer-->
            <div [ngStyle]="getFooterStyle(template.footer, page)">
              <ng-container
                *ngTemplateOutlet="
                  textTemplate;
                  context: { texts: template.footer.texts, pageNumber: pageIndex, pageCount: filteredPages.length }
                "
              >
              </ng-container>
              <ng-container *ngTemplateOutlet="imageTemplate; context: { images: template.footer.images }"> </ng-container>
              <ng-container *ngTemplateOutlet="lineTemplate; context: { lines: template.footer.lines }"> </ng-container>
              <ng-container *ngTemplateOutlet="rectTemplate; context: { rectangles: template.footer.rectangles }"> </ng-container>
              <ng-container *ngTemplateOutlet="signatureTemplate; context: { signs: template.footer.signatures }"> </ng-container>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
} @else {
  <h4 class="ipm-report__loading-page">{{ 'measurementReport.loadingTemplate' | translate }}</h4>
}

<ng-template #isoTemplate let-interactiveIso="interactiveIso">
  @for (iso of interactiveIso; track iso.id) {
    @if (iso.isoType === 'Redline') {
      @if (!updatedIsoImage[iso.index]) {
        <img
          [id]="'redlineImg' + iso.index"
          class="ipm-inspection__redlining-layer"
          [style.position]="'absolute'"
          [style.max-width]="iso.width + 'mm'"
          [style.max-height]="iso.height + 'mm'"
          [src]="redlineImageData[iso.index]"
          [attr.data-meta]="isoImageMetaInfo[iso.index]?.fileId"
          (load)="redlineImageLoaded(iso.redlineData, iso.index)"
        />
      }
      @if (!updatedIsoImage[iso.index]) {
        <canvas
          [id]="'redlineCanvas' + iso.index"
          class="ipm-inspection__redlining-layer"
          [style.position]="'absolute'"
          [style.width]="iso.width + 'mm'"
          [style.height]="iso.height + 'mm'"
        ></canvas>
      }
      @if (updatedIsoImage[iso.index]) {
        <div [ngStyle]="getStyle(iso)">
          <img
            [style.position]="'absolute'"
            [style.max-width]="iso.width + 'mm'"
            [style.max-height]="iso.height + 'mm'"
            [style.background-image]="'url(' + redlineImageData[iso.index] + ')'"
            style="left: 0; right: 0; top: 0; margin: auto; bottom: 0; background-size: contain"
            [src]="updatedIsoImage[iso.index]"
            [attr.back-data-meta]="isoImageMetaInfo[iso.index]?.fileId"
            alt="Image not available"
          />
        </div>
      }
    }
    @if (iso.isoType === 'VisualEvent') {
      <div [id]="'veImgContainer' + iso.index" [ngStyle]="getStyle(iso)">
        <img
          [id]="'veImg' + iso.index"
          [style.position]="'absolute'"
          [style.max-width]="iso.width + 'mm'"
          [style.max-height]="iso.height + 'mm'"
          [src]="isoImageUris[iso.index]"
          [style]="'left: 0;right: 0;top: 0;margin: auto;bottom: 0;'"
          [attr.data-meta]="isoImageMetaInfo[iso.index]?.fileId"
          alt="Image not available"
          (load)="veImageLoaded(iso.index)"
        />
        @if (veISOLoaded[iso.index]) {
          @for (marker of visualEventsMarkers[iso.index]; track marker; let i = $index) {
            @for (location of marker.locations; track location; let locIndex = $index) {
              <span
                [ngStyle]="staticStyles.visualEventMarkerBtn"
                [style.left]="location.left + (addOffsets ? veOffsets[iso.index].width : 0) + 'px'"
                [id]="'visualEventLoc' + i + 'iso' + iso.index"
                [style.top]="location.top + (addOffsets ? veOffsets[iso.index].height : 0) + 'px'"
              >
                <mat-icon [ngStyle]="staticStyles.visualEventMarkerIcon" svgIcon="icon-visual-bullseye"></mat-icon>
                <span style="position: absolute; bottom: -1.5rem; left: -0.25rem; font-weight: bold; color: black">{{
                  marker.visualEventType | visualEventType
                }}</span>
              </span>
            }
          }
        }
      </div>
    }
    @if (iso.isoType === 'UTT') {
      <div [id]="'cmlImgContainer' + iso.index" [ngStyle]="getStyle(iso)">
        <img
          [id]="'cmlImg' + iso.index"
          [style.position]="'absolute'"
          [style.max-width]="iso.width + 'mm'"
          [style.max-height]="iso.height + 'mm'"
          [src]="isoImageUris[iso.index]"
          [style]="'left: 0;right: 0;top: 0;margin: auto;bottom: 0;'"
          [attr.data-meta]="isoImageMetaInfo[iso.index]?.fileId"
          alt="Image not available"
          (load)="cmlImageLoaded(iso.index)"
        />
        @if (cmlISOLoaded[iso.index]) {
          <ul [ngStyle]="staticStyles.cmls">
            @for (cml of cmls[iso.index]; track cml; let i = $index) {
              <li
                [ngStyle]="getCmlStyles(cml)"
                [style.left]="cml.location.left + (addOffsets ? cmlOffsets[iso.index].width : 0) + 'px'"
                [style.top]="cml.location.top + (addOffsets ? cmlOffsets[iso.index].height : 0) + 'px'"
                [style.height.px]="cmlBubbleHeight"
                [id]="'cml' + i + 'iso' + iso.index"
                [style.width.px]="cmlBubbleHeight"
              >
                <p [ngStyle]="staticStyles.cmlLabel">{{ cml.label }}</p>
              </li>
            }
          </ul>
        }
      </div>
    }
  }
</ng-template>

<ng-template #measurementPointTemplate let-measurementPoints="measurementPoints">
  @if (measurementPoints && measurementPoints.length > 0) {
    <div style="position: absolute; width: 100%">
      <div
        style="height: 9mm; padding: 0 5mm; font-weight: bold"
        [style.fontSize]="measurementPoints[0].titleFontSize + 'mm'"
        [style.textAlign]="measurementPoints[0].titleAlign"
        [style.backgroundColor]="measurementPoints[0].titleBackgroundColor"
      >
        {{ measurementPoints[0].titleText }}
      </div>
      @for (table of measurementPoints; track table) {
        <div [ngStyle]="getTableContainerStyle(table)">
          @for (tableIndex of table.tableIndex; track tableIndex; let index = $index; let tableIndexLength = $count) {
            <div
              [style.padding]="table.tableMargin + 'mm'"
              [attr.data-measurement-source-page-index]="table.dataSourceIndex"
              [attr.data-measurement-table-index]="tableIndex"
            >
              <table rules="{{ table.tableRules }}" [ngStyle]="getTableStyle(table, index)">
                <thead>
                  <tr [style.height]="1.35 * table.fontSize + 'mm'">
                    @for (column of table.columns; track column) {
                      <th
                        [style.padding]="table.cellMargin + 'mm'"
                        align="left"
                        [style.width]="column.widthRatio ? column.widthRatio + '%' : 'unset'"
                        style="white-space: nowrap"
                      >
                        {{ column.label }}
                      </th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (id of getMeasurementPointData(table, tableIndex); track id; let rowIndex = $index; let even = $even) {
                    @if (showMeasurementPointRow(table, rowIndex, index, tableIndexLength)) {
                      <tr
                        [style.height]="1.35 * table.fontSize + 'mm'"
                        [ngStyle]="getMeasurementRowStyle(table, even, id)"
                        [attr.data-measurement-row-index]="rowIndex"
                      >
                        @for (column of table.columns; track column) {
                          <td [style.padding]="table.cellMargin + 'mm'" align="left">
                            @if (column.type !== 'Editable') {
                              @if (isValidationOn) {
                                @if (column.dataField === 'id') {
                                  <span style="display: flex">
                                    @if (rowIdContainStar(id)) {
                                      <span style="color: red">*</span>
                                    }
                                    {{ replaceStar(id[column.dataField]) }}
                                  </span>
                                }
                                @if (column.dataField === 'measurement') {
                                  <span>
                                    @if (isCurrentMeasurementNotTaken(id)) {
                                      <span style="color: red">*required</span>
                                    }
                                    @if (!isCurrentMeasurementNotTaken(id)) {
                                      <span>{{ id[column.dataField] }}</span>
                                    }
                                  </span>
                                }
                                @if (column.dataField === 'comment') {
                                  <span>
                                    @if (isCommentRequiredOrNot(id)) {
                                      <span style="color: red">*required</span>
                                    }
                                    @if (!isCommentRequiredOrNot(id)) {
                                      <span>{{ id[column.dataField] }}</span>
                                    }
                                  </span>
                                }
                                @if (
                                  column.type !== 'Dynamic-Editable' &&
                                  column.dataField !== 'id' &&
                                  column.dataField !== 'measurement' &&
                                  column.dataField !== 'comment'
                                ) {
                                  <span>{{ id[column.dataField] }}</span>
                                }
                              }
                              @if (!isValidationOn) {
                                @if (column.dataField === 'id') {
                                  <span style="display: flex">
                                    @if (rowIdContainStar(id)) {
                                      <span style="color: red">*</span>
                                    }
                                    {{ replaceStar(id[column.dataField]) }}</span
                                  >
                                }
                                @if (column.dataField === 'measurement') {
                                  <span>
                                    @if (isCurrentMeasurementNotTaken(id)) {
                                      <span>0</span>
                                    }
                                    @if (!isCurrentMeasurementNotTaken(id)) {
                                      <span>{{ id[column.dataField] }}</span>
                                    }
                                  </span>
                                }
                                @if (column.dataField === 'comment') {
                                  <span>
                                    @if (isCommentRequiredOrNot(id)) {
                                      <span></span>
                                    }
                                    @if (!isCommentRequiredOrNot(id)) {
                                      <span>{{ id[column.dataField] }}</span>
                                    }
                                  </span>
                                }
                                @if (
                                  column.type !== 'Dynamic-Editable' &&
                                  column.dataField !== 'id' &&
                                  column.dataField !== 'measurement' &&
                                  column.dataField !== 'comment'
                                ) {
                                  <span>{{ id[column.dataField] }}</span>
                                }
                              }
                            }
                            @if (column.type === 'Editable') {
                              @if (id.allowEdit !== column.label && column.inputType !== 'checkbox' && column.inputType !== 'select') {
                                <div
                                  [ngStyle]="staticStyles.contentFit"
                                  [style.minHeight]="'20px'"
                                  [ngClass]="{ 'ipm-report__editable-field': !previewMode }"
                                  (click)="id.allowEdit = column.label; focusElements()"
                                >
                                  {{ id[column.label] }}
                                </div>
                              }
                              @if (column.inputType === 'checkbox') {
                                <input
                                  type="checkbox"
                                  name="{{ column.inputGroup }}"
                                  [(ngModel)]="id[column.label]"
                                  (ngModelChange)="checkChanges()"
                                  [checked]="id[column.label]"
                                  [disabled]="previewMode"
                                  [attr.checked]="id[column.label] ? true : null"
                                />
                              }
                              @if (column.inputType === 'select') {
                                <mat-form-field
                                  appearance="fill"
                                  (blur)="id.allowEdit = false"
                                  [ngStyle]="staticStyles.contentFit"
                                  subscriptSizing="dynamic"
                                >
                                  <mat-label>Choose an option</mat-label>
                                  <mat-select [(ngModel)]="id[column.label]" (ngModelChange)="checkChanges()" [disabled]="previewMode">
                                    @for (option of column.optionList; track option) {
                                      <mat-option [value]="option">{{ option }}</mat-option>
                                    }
                                  </mat-select>
                                </mat-form-field>
                              }
                              @if (id.allowEdit === column.label && !previewMode) {
                                @if (column.inputType === 'text') {
                                  <input
                                    type="text"
                                    [ngStyle]="staticStyles.contentFit"
                                    maxlength="150"
                                    [(ngModel)]="id[column.label]"
                                    (ngModelChange)="checkChanges()"
                                    (blur)="id.allowEdit = undefined"
                                  />
                                }
                              }
                            }
                            @if (column.type === 'Dynamic-Editable') {
                              @if (id.allowEdit === undefined || id.allowEdit !== column.label) {
                                <div
                                  [ngStyle]="staticStyles.contentFit"
                                  [style.minHeight]="'20px'"
                                  [ngClass]="{ 'ipm-report__editable-field': !previewMode }"
                                  (click)="editDynamicValueClick(id, column)"
                                >
                                  @if (isValidationOn && isCheckDynamicEditable(id, column.dataField)) {
                                    <span style="color: red">*required</span>
                                  }
                                  @if (isDynamicEditableValueUpdated(id, column.dataField)) {
                                    <span style="color: red">*</span>
                                  }
                                  @if (!isCheckDynamicEditable(id, column.dataField)) {
                                    <span>{{ id[column.dataField] }}</span>
                                  }
                                </div>
                              }
                              <!--TODO : set maxlength from CSV data -->
                              @if (id.allowEdit === column.label && !previewMode) {
                                <input
                                  type="text"
                                  [ngStyle]="staticStyles.contentFit"
                                  maxlength="150"
                                  [(ngModel)]="id[column.dataField]"
                                  (ngModelChange)="checkChanges()"
                                  (blur)="id.allowEdit = undefined"
                                />
                              }
                            }
                          </td>
                        }
                      </tr>
                    }
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #veTemplate let-visualEvents="visualEvents">
  @for (visualEvent of visualEvents; track visualEvent) {
    <div style="position: absolute; width: 100%">
      <div
        style="height: 9mm; padding: 0 5mm; font-weight: bold"
        [style.fontSize]="visualEvent.titleFontSize + 'mm'"
        [style.textAlign]="visualEvent.titleAlign"
        [style.backgroundColor]="visualEvent.titleBackgroundColor"
      >
        {{ visualEvent.titleText }}
      </div>
      <div style="display: inline">
        @for (veIndex of visualEvent.visualEventIndex; track veIndex) {
          <div [ngStyle]="getVisualEventContainerStyle(visualEvent, veIndex)" [style.float]="'left'">
            <div style="display: flex; flex-direction: column">
              <div [ngStyle]="getVisualEventImageContainerStyle(visualEvent, veIndex)" style="display: flex; flex-wrap: wrap">
                @for (imageData of splitVEData[veIndex]['images']; track imageData; let i = $index) {
                  <div [ngStyle]="{ flex: splitVEData[veIndex]['images']?.length > 1 ? '0 0 50%' : '0 0 100%' }" style="position: relative">
                    @if (i < 6) {
                      <img
                        [ngStyle]="staticStyles.vePhoto"
                        style="left: 0; right: 0; top: 0; margin: auto; bottom: 0; margin-left: 1rem"
                        [src]="imageData.imageUrl | offlineImage | async"
                        [attr.data-meta]="imageData?.fileId"
                      />
                    }
                    @for (caption of visualEvent.captionsList; track caption) {
                      <div style="min-height: 5mm; font-size: 3mm; margin-left: 1rem">
                        <span style="padding: 0 0.5rem"
                          ><b>{{ caption.label }}</b></span
                        >
                        <span style="padding: 0 0.5rem; word-break: break-word"
                          ><b>{{ getVisualEventCaption(caption, veIndex, true) }}</b></span
                        >
                      </div>
                    }
                  </div>
                }
                @if (splitVEData[veIndex]['images']?.length === 0) {
                  <div [ngStyle]="staticStyles.noContent">
                    {{ 'measurementReport.noPhoto' | translate }}
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</ng-template>

<ng-template #lineTemplate let-lines="lines">
  @for (line of lines; track line) {
    <div [ngStyle]="getStyle(line)"></div>
  }
</ng-template>

<ng-template #rectTemplate let-rect="rectangles">
  @for (rectangle of rect; track rectangle) {
    <div [ngStyle]="getStyle(rectangle)"></div>
  }
</ng-template>

<ng-template #textTemplate let-texts="texts" let-pageNumber="pageNumber" let-pageCount="pageCount">
  @for (text of texts; track text) {
    @if (text.inputType !== 'radio') {
      @if (text.type === 'static') {
        <div [ngStyle]="getStyle(text)">{{ text.text }}</div>
      }
      @if (text.type === 'dynamic') {
        <div
          [ngStyle]="getStyle(text)"
          (click)="bindData(text)"
          [innerHtml]="getDynamicText(text.dynamicDataField, text.dynamicId, text.format, pageNumber, pageCount)"
        ></div>
      }
      @if (text.type === 'dynamic-editable' && !text.editMode) {
        <div [ngStyle]="getStyle(text)" [ngClass]="{ 'ipm-report__editable-field': !previewMode }" (click)="enableEditMode(text)">
          @if (text.isChanged && text.isValid) {
            <span style="color: red">*</span>
          }
          @if (!text.isValid) {
            <span style="color: red">*required</span>
          }
          @if (text.inputType !== 'textArea') {
            <span>{{ text.text }}</span>
          } @else {
            <pre class="ipm-report__pre-field">{{ text.text }}</pre>
          }
        </div>
      }
    }
    @if (text.inputType === 'radio') {
      @if (text.type === 'static') {
        @if (text.radioType === 'check') {
          <div [ngStyle]="getStyle(text)">
            <input
              type="checkbox"
              name="{{ text.inputGroup }}"
              [(ngModel)]="text.value"
              (ngModelChange)="checkChanges()"
              [checked]="text.value"
              [disabled]="previewMode"
              [attr.checked]="text.value ? true : null"
            />
            {{ text.text }}
          </div>
        }
        @if (text.radioType === 'radio') {
          <div [ngStyle]="getStyle(text)">
            <input
              type="radio"
              name="{{ text.inputGroup }}"
              [(ngModel)]="text.value"
              (ngModelChange)="checkChanges()"
              [checked]="text.value"
              [disabled]="previewMode"
              [attr.checked]="text.value ? true : null"
            />
            {{ text.text }}
          </div>
        }
      }
      @if ((text.type === 'dynamic' || text.type === 'dynamic-editable') && !text.editMode) {
        @if (text.radioType === 'check') {
          <div [ngStyle]="getStyle(text)" [ngClass]="{ 'ipm-report__editable-field': !previewMode }">
            <input
              type="checkbox"
              name="{{ text.inputGroup }}"
              [(ngModel)]="text.value"
              (ngModelChange)="checkChanges()"
              [checked]="text.value"
              [disabled]="previewMode"
              [attr.checked]="text.value ? true : null"
            />
          </div>
        }
        @if (text.radioType === 'radio') {
          <div [ngStyle]="getStyle(text)" [ngClass]="{ 'ipm-report__editable-field': !previewMode }">
            <input
              type="radio"
              name="{{ text.inputGroup }}"
              [(ngModel)]="text.value"
              (ngModelChange)="checkChanges()"
              [checked]="text.value"
              [disabled]="previewMode"
              [attr.checked]="text.value ? true : null"
            />
          </div>
        }
      }
    }
    @if (text.editMode) {
      @if (text.inputType === 'text') {
        <input
          type="text"
          [ngStyle]="getStyle(text)"
          [(ngModel)]="text.text"
          (ngModelChange)="checkDynamicEditChanges(text)"
          (blur)="disableEditMode(text)"
          [maxlength]="text.validation.maxLength"
        />
      }
      @if (text.inputType === 'textArea') {
        <textarea
          [ngStyle]="getStyle(text)"
          [(ngModel)]="text.text"
          (ngModelChange)="checkDynamicEditChanges(text)"
          (blur)="disableEditMode(text)"
          [maxlength]="text.validation.maxLength"
        ></textarea>
      }
      @if (text.inputType === 'date') {
        <input
          type="text"
          [ngStyle]="getStyle(text)"
          [(ngModel)]="text.text"
          (ngModelChange)="checkChanges()"
          (blur)="disableEditMode(text)"
          [maxlength]="text.validation.maxLength"
        />
      }
      @if (text.inputType === 'select') {
        <select [ngStyle]="getStyle(text)" (blur)="disableEditMode(text)" [(ngModel)]="text.text" (ngModelChange)="checkChanges()">
          @for (option of text.options; track option) {
            <option [value]="option.value">{{ option.label }}</option>
          }
        </select>
      }
      @if (text.inputType === 'multiSelect') {
        <mat-select
          multiple
          [ngStyle]="getStyle(text)"
          (openedChange)="selectEdit(text, $event)"
          [(ngModel)]="text.text"
          (ngModelChange)="checkChanges()"
        >
          @for (option of text.options; track option) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
      }
    }
  }
</ng-template>

<ng-template #imageTemplate let-images="images">
  @for (image of images; track image) {
    @if (image.sectionStageTag !== 'InteractiveDiagram') {
      @if (image.type === 'static') {
        @if (isMobile) {
          <img
            [ngStyle]="getStyle(image)"
            [attr.data-meta]="getOfflineImage(image)"
            [src]="getOfflineImage(image) | offlineImage | async"
            alt="static image"
          />
        } @else {
          <img [ngStyle]="getStyle(image)" [src]="image.src" alt="Image not available" />
        }
      }
      @if (image.type === 'dynamic') {
        @if (image.dynamicId === 'photoGallery') {
          <div style="display: inline">
            @for (pgIndex of image.photoGalleryIndex; track pgIndex) {
              <div [ngStyle]="getPhotoGalleryContainerStyle(image, pgIndex)" [style.float]="'left'">
                <div style="display: flex; flex-direction: column">
                  <div [ngStyle]="getPhotoGalleryImageContainerStyle(image, pgIndex)" style="display: flex; flex-wrap: wrap">
                    @for (image of photoEventsData[pgIndex]?.images; track image; let i = $index) {
                      <div
                        [ngStyle]="{ flex: photoEventsData[pgIndex]?.images?.length > 1 ? '0 0 50%' : '0 0 100%' }"
                        style="position: relative"
                      >
                        @if (i < 6) {
                          <img
                            [ngStyle]="staticStyles.vePhoto"
                            style="left: 0; right: 0; top: 0; margin: auto; bottom: 0; position: absolute"
                            [src]="image.imageUrl | offlineImage | async"
                            [attr.data-meta]="image?.fileId"
                          />
                        }
                      </div>
                    }
                    @if (photoEventsData[pgIndex]?.images?.length === 0) {
                      <div [ngStyle]="staticStyles.noContent">
                        {{ 'measurementReport.noPhoto' | translate }}
                      </div>
                    }
                  </div>
                  <div style="height: 5mm; font-size: 3mm">
                    <span style="padding: 0 0.5rem"
                      ><b>{{ 'measurementReport.EventType' | translate }} :</b></span
                    >
                    <span style="padding: 0 0.5rem; word-break: break-all"
                      ><b>{{
                        photoEventsData[pgIndex]?.visualEventType === 'None'
                          ? ('measurementReport.Others' | translate)
                          : photoEventsData[pgIndex]?.visualEventType
                      }}</b></span
                    >
                  </div>
                  <div style="height: 5mm; font-size: 3mm">
                    <span style="padding: 0 0.5rem"
                      ><b> {{ 'measurementReport.Description' | translate }} :</b></span
                    >
                    <span style="padding: 0 0.5rem; word-break: break-all"
                      ><b>{{ photoEventsData[pgIndex]?.description }}</b></span
                    >
                  </div>
                </div>
              </div>
            }
          </div>
        } @else {
          @if (isMobile) {
            <img
              [ngStyle]="getStyle(image)"
              [attr.data-meta]="image.id"
              [src]="getOfflineImage(image) | offlineImage | async"
              alt="Image not available!!"
            />
          } @else {
            <img [ngStyle]="getStyle(image)" [src]="getDynamicText(image.dynamicDataField)" alt="Image not available!!" />
          }
        }
      }
      @if (image.type === 'dynamic-editable') {
        @if (isMobile) {
          @if (isImageuploaded) {
            <img
              [ngStyle]="getStyle(image)"
              style="object-fit: contain"
              [attr.data-meta]="image.id"
              [src]="image.src | offlineImage | async"
              alt="Image not available!!"
              (click)="takeReportSnapshot(image)"
            />
          } @else {
            <img
              [ngStyle]="getStyle(image)"
              style="object-fit: contain"
              [attr.data-meta]="image.id"
              [src]="getOfflineImage(image) | offlineImage | async"
              alt="Image not available"
              (click)="takeReportSnapshot(image)"
            />
          }
        } @else {
          <img
            [ngStyle]="getStyle(image)"
            style="object-fit: contain"
            [attr.data-meta]="image.id"
            [src]="image.src | offlineImage | async"
            alt="Image not available!!"
            (click)="takeReportSnapshot(image)"
          />
        }
      }
    }
  }
</ng-template>

<ng-template #signatureTemplate let-signs="signs">
  @for (signature of signs; track signature) {
    <div
      [ngStyle]="getStyle(signature)"
      [style.borderWidth]="signature.borderWidth + 'mm'"
      [style.borderStyle]="signature.borderStyle"
      [style.borderColor]="signature.borderColor"
    >
      <div [style.padding]="'3mm'">
        <span>{{ signature.reservedFor }} {{ 'measurementReport.signature' | translate }} </span>
      </div>
      <div [style.height]="'24mm'">
        <div [style.margin]="'0 3mm 3mm 3mm'" [style.height]="'20mm'" [style.borderBottom]="'1px solid black'" [style.float]="'center'">
          @if (hasTemplateSignature(signature)) {
            <img style="width: 100%; height: 100%" [src]="getSignature(signature)" />
          }
        </div>
      </div>
      <div [style.padding]="'1mm 3mm'">
        <span [style.width]="'30mm'" [style.textAlign]="'center'"
          ><b>{{ 'measurementReport.name' | translate }} : </b></span
        >
        @if (hasTemplateSignature(signature)) {
          <span [innerHtml]="getSigneeName(signature)"></span>
        }
      </div>
      <div [style.padding]="'1mm 3mm'">
        <span [style.width]="'30mm'" [style.textAlign]="'center'"
          ><b>{{ 'measurementReport.date' | translate }} : </b></span
        >
        @if (hasTemplateSignature(signature)) {
          <span [innerHtml]="getSignatureDate(signature)"></span>
        }
      </div>
    </div>
  }
</ng-template>

<ng-template #dropDownListsTemplate let-dropdownLists="dropdownLists">
  @for (dropDownList of dropdownLists; track dropDownList) {
    <mat-form-field
      appearance="fill"
      [ngStyle]="getStyle(dropDownList)"
      [style.paddingTop]="'3px'"
      [style.paddingLeft]="'3px'"
      [style.paddingBottom]="'3px'"
      [style.paddingRight]="'3px'"
      [style.maxHeight]="'10px'"
      (blur)="disableEditMode(dropDownList)"
    >
      <mat-label>Choose an option</mat-label>
      <mat-select
        [(ngModel)]="dropDownList.selectedValue"
        [ngStyle]="getDropDownStyle(dropDownList)"
        [disabled]="previewMode"
        [style.color]="previewMode ? 'black' : 'black'"
        [style.opacity]="previewMode ? '1' : '1'"
        [style.overflow-wrap]="'break-word'"
      >
        @for (option of dropDownList.options; track option) {
          <mat-option [value]="option.value" [attr.selected]="dropDownList.selectedValue === option.value ? 'selected' : null"
            >{{ option.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</ng-template>

<ng-template #tableTemplate let-tables="tables">
  @for (table of tables; track table; let tableIndex = $index) {
    <div
      [style.top]="table.y + 'mm'"
      [style.left]="table.x + 'mm'"
      [style.width]="table.width + 'mm'"
      [style.height]="table.height + 'mm'"
      [style.position]="'absolute'"
    >
      @if (table.tableType === 'surveyTable') {
        <table
          [style.top]="table.y + 'mm'"
          [style.left]="table.x + 'mm'"
          [style.width]="table.width + 'mm'"
          [style.height]="table.height + 'mm'"
          [style.fontSize]="table.fontSize + 'mm'"
          [ngStyle]="staticStyles.veListTable"
        >
          <thead>
            <tr>
              <th [style.border]="'none'"></th>
              @for (column of table?.columnList; track column) {
                <th
                  [style.width]="column.width + 'mm'"
                  [style.border]="table?.cellBorder"
                  [style.padding]="table?.cellPadding + 'mm'"
                  [style.textAlign]="column.textAlignment"
                >
                  <p [ngStyle]="getColumnStyle(column)">{{ column?.label }}</p>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of table | reportTable: allVisualEventData; track row; let i = $index) {
              <tr>
                @if (table.rowList[i].isCategory) {
                  <th
                    colspan="100%"
                    [style.border]="table?.cellBorder"
                    [style.padding]="table?.cellPadding + 'mm'"
                    [style.textAlign]="table.rowList[i].textAlignment"
                  >
                    {{ row?.label }}
                    @if (row.isShow) {
                      <span style="color: red">*</span>
                    }
                  </th>
                }
                @if (!table.rowList[i].isCategory) {
                  <th
                    [style.border]="table?.cellBorder"
                    [style.padding]="table?.cellPadding + 'mm'"
                    [style.textAlign]="table.rowList[i].textAlignment"
                  >
                    {{ row?.label }}
                    @if (row.isShow) {
                      <span style="color: red">*</span>
                    }
                  </th>
                }
                @for (column of table?.columnList; track column) {
                  <td
                    [style.display]="table.rowList[i].isCategory ? 'none' : ''"
                    [style.border]="table?.cellBorder"
                    [style.padding]="table?.cellPadding + 'mm'"
                    [style.textAlign]="column.textAlignment"
                  >
                    @if (row[column.label].inputType === 'checkbox') {
                      <input
                        type="checkbox"
                        name="{{ row.label }}"
                        [(ngModel)]="row[column.label].column.data"
                        (ngModelChange)="checkChanges()"
                        [disabled]="!row[column.label].isEditable || previewMode"
                        [checked]="row[column.label].column.data"
                        [attr.checked]="row[column.label].column.data ? true : null"
                        (change)="row[column.label].isDataEntered = true"
                        (mouseleave)="updateCheckboxOnMosueLeave(table.id, tableIndex, i, row, column)"
                      />
                    }
                    @if (row[column.label].inputType === 'select') {
                      <mat-form-field
                        appearance="fill"
                        [ngStyle]="staticStyles.contentFit"
                        subscriptSizing="dynamic"
                        (blur)="row[column.label].allowEdit = false"
                      >
                        <mat-label>Choose an option</mat-label>
                        <mat-select [(ngModel)]="row[column.label].column.data" [disabled]="previewMode" (ngModelChange)="checkChanges()">
                          @for (itm of table.priorityList; track itm) {
                            <mat-option [value]="itm.label">{{ itm.label }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                    @if (row[column.label].inputType === 'radio') {
                      <input
                        type="radio"
                        name="{{ row.label + i }}"
                        [checked]="row[column.label].column.data"
                        [disabled]="table.type !== 'dynamic-editable'"
                        [value]="true"
                        [attr.checked]="row[column.label].column.data ? true : null"
                        (change)="updateRadioInputs(table.id, tableIndex, i, row, column)"
                      />
                    }
                    @if (row[column.label].inputType === 'text' || row[column.label].inputType === 'textarea') {
                      <div [ngStyle]="staticStyles.contentFit">
                        <div
                          [ngStyle]="staticStyles.contentFit"
                          (click)="
                            row[column.label].allowEdit = row[column.label].isEditable ? true : false;
                            row[column.label].isDataEntered = true;
                            focusElements()
                          "
                        >
                          {{ row[column.label].column.data }}
                        </div>
                      </div>
                    }
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      }
      @if (table.tableType === 'genericTable') {
        <table
          [style.top]="table.y + 'mm'"
          [style.left]="table.x + 'mm'"
          [style.width]="table.width + 'mm'"
          [style.fontSize]="table.fontSize + 'mm'"
          [ngStyle]="staticStyles.veListTable"
        >
          <thead>
            <tr>
              @for (column of table?.columnList; track column) {
                <th
                  [style.width]="column.width + 'mm'"
                  [style.border]="table?.cellBorder"
                  [style.padding]="table?.cellPadding + 'mm'"
                  [style.textAlign]="column.textAlignment"
                >
                  <p [ngStyle]="getColumnStyle(column)">{{ column?.label }}</p>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (event of table?.dataSource; track event) {
              <tr [style.height]="'14mm'">
                @for (column of table?.columnList; track column; let i = $index) {
                  <td
                    [style.border]="table?.cellBorder"
                    [style.padding]="table?.cellPadding + 'mm'"
                    [style.textAlign]="column.textAlignment"
                  >
                    @if (column.dataField === 'location') {
                      <div>{{ event[column.dataField] | json }}</div>
                    }
                    @if (column.dataField === 'visualEventType') {
                      <div>{{ event.visualEventType }}</div>
                    }
                    @if (column.dataField !== 'visualEventType' && column.dataField !== 'location' && column.inputType !== 'image') {
                      <div>{{ event[column.dataField] }}</div>
                    }
                    @if (column.inputType === 'image' && event[column.dataField]) {
                      <img style="width: 100%; height: 100%" [src]="event[column.dataField]" />
                    }
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  }
</ng-template>
